'use client';

import React, { useEffect, useState } from "react";
import { useAuth } from "../components/AuthContext";
import { usePathname, useRouter } from "next/navigation";
import { motion } from "motion/react";

const Auth = ({children}: any) => {
    const { isAuthenticated, user } = useAuth();
    const router = useRouter();
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
    const animRef = React.useRef<HTMLDivElement>(null);
    const pathname = usePathname();

    // move 'px_auth_anim' on mouse
    useEffect(() => {
        const handleMouseMove = (event: MouseEvent) => {
            setMousePosition({
                x: event.clientX,
                y: event.clientY
            });
            setTimeout(() => {
                if(animRef.current && animRef.current.style) {
                    animRef.current.style.opacity = '0.3';
                }
            }, 200);
        };
        window.addEventListener('mousemove', handleMouseMove);
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
        };
    }, []);

    useEffect(() => {
        if (user && isAuthenticated) {
            if (user.role === 'admin') {
                router.push('/admin/dashboard');
            } else if (user.role === 'user') {
                router.push('/dashboard');
            }
        }
    }, [user, isAuthenticated, router]);

    return (
        <>
            <main className="px_auth_wrapper">
                <div className="px_auth_bg">
                    <div className="px_auth_bg_inner"></div>
                    <div className="px_auth_anim" ref={animRef} style={{
                        transform: `translate(calc(-50% + ${mousePosition.x}px), calc(-50% + ${mousePosition.y}px))`
                    }}></div>
                </div>
                <div className="px_auth_inner">
                    <div className="px_auth_form">
                        <motion.div
                            key={pathname}
                            initial={{ opacity: 0, y: -50, scale: 0.9 }}
                            animate={{ opacity: 1, y: 0, scale: 1 }}
                            className="px_auth_form_inner">
                            <img className="max-w-[160px] mb-4" src="assets/images/logo.svg" alt="" />
                            {children}
                        </motion.div>
                    </div>
                </div>
            </main>
        </>
    );
}

export default Auth;